import React, { useEffect, useMemo, useRef, useState } from 'react'
import Recaptcha from 'react-google-invisible-recaptcha'
import injectSheet from 'react-jss/lib/injectSheet'
import { apiClient } from 'pobble-components/dist/api'

const styles = {
  '@global': {
    '.grecaptcha-badge': {
      display: 'none'
    }
  }
}

const PobbleReCaptcha = injectSheet(styles)(
  // eslint-disable-next-line no-unused-vars
  ({ classes, nodeRef, ...props }) => {
    const [sitekey, setSitekey] = useState(null)
    useEffect(() => {
      apiClient
        .get('v3/keys?include=recaptcha_site_key')
        .then(res => setSitekey(res.data.recaptcha_site_key))
    }, [])
    return !sitekey ? null : (
      <Recaptcha.default sitekey={sitekey} ref={nodeRef} {...props} />
    )
  }
)

export const useRecaptcha = () => {
  const recaptchaRef = useRef(null)
  const callbackRef = useRef(null)
  const [token, setToken] = useState(null)
  const [pending, setPending] = useState(false)

  useEffect(() => {
    if (token) {
      setPending(false)
      callbackRef.current && callbackRef.current(token)
      reset()
    }
  }, [token])

  const reset = () => {
    if (recaptchaRef.current) {
      recaptchaRef.current.reset()
      setPending(false)
      setToken(null)
    }
  }

  const getReCaptchaToken = callback => {
    if (!pending) {
      if (recaptchaRef.current && recaptchaRef.current.execute) {
        setPending(true)
        setTimeout(() => setPending(false), 1000)
        callbackRef.current = callback
        recaptchaRef.current.execute()
      }
    }
  }

  const recaptchaProps = useMemo(
    () => ({
      nodeRef: ref => {
        recaptchaRef.current = ref
      },
      onResolved: setToken,
      onError: reset,
      onExpired: reset
    }),
    [setToken]
  )

  return {
    recaptchaProps,
    Recaptcha: PobbleReCaptcha,
    getReCaptchaToken,
    recaptchaToken: token,
    recaptchaPending: pending
  }
}
